import React, { useCallback, useMemo, useState } from "react";
import RSC, { ScrollbarProps } from "react-scrollbars-custom";
import { ElementPropsWithElementRefAndRenderer } from "react-scrollbars-custom/dist/types/types";

import defaultProps from "./defaultProps";

export function Scrollbar({ children, ...props }: ScrollbarProps) {
  const [isScrolling, setIsScrolling] = useState(false);
  const [isMouseOver, setIsMouseOver] = useState(false);
  const isShow = isScrolling || isMouseOver;

  const onScrollStart = useCallback(() => {
    setIsScrolling(true);
  }, []);
  const onScrollStop = useCallback(() => {
    setIsScrolling(false);
  }, []);
  const onMouseEnter = useCallback(() => {
    setIsMouseOver(true);
  }, []);
  const onMouseLeave = useCallback(() => {
    setIsMouseOver(false);
  }, []);

  const trackProps = useMemo(() => ({
    renderer: ({ elementRef, style, ...restProps }: ElementPropsWithElementRefAndRenderer) => (
      <span
        {...restProps}
        ref={elementRef}
        style={{ ...style, opacity: isShow ? 1 : 0, transition: "opacity 0.4s ease-in-out", }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    )
  }), [isShow, onMouseEnter, onMouseLeave]);

  return (
    <RSC
      {...defaultProps}
      {...(props.style ? { style: props.style } : {})}
      trackXProps={trackProps}
      trackYProps={trackProps}
      onScrollStart={onScrollStart}
      onScrollStop={onScrollStop}
    >
      {
        React.Children.toArray(children).map((child) => (
          React.isValidElement(child)
            ? React.cloneElement(child, { isScrolling })
            : child
        ))
      }
    </RSC>
  );
}
